import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

const initSingleProductGallery = () => {
    const galleries = document.querySelectorAll('[data-single-product-gallery]');
    if (!galleries.length) return;

    galleries.forEach(el => {
        if (el.dataset.galleryInit) return;
        el.dataset.galleryInit = '1';

        const slides = el.querySelectorAll('.swiper-slide');
        if (slides.length <= 1) {
            el.classList.add('is-single');
            return;
        }

        const paginationEl = el.querySelector('[data-single-product-pagination]');

        new Swiper(el, {
            modules: [Pagination],
            slidesPerView: 1,
            loop: false,
            pagination: {
                el: paginationEl,
                clickable: true,
            },
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSingleProductGallery);
} else {
    initSingleProductGallery();
}
